import React from "react";
import { NavLink } from "react-router-dom";
import Hidden from '@material-ui/core/Hidden';

import { withStyles, Card, CardContent, CardHeader, CardActions, Typography, Grid } from "material-ui";

import EthAlt from 'react-cryptocoins/dist/icons/ETH-alt';

// @material-ui/icons
import LocalOffer from "@material-ui/icons/LocalOffer";
import People from "@material-ui/icons/People";


import PropTypes from "prop-types";

import { ItemGrid } from "components";

import chartCardStyle from "assets/jss/material-dashboard-react/chartCardStyle";

import StarRatingComponent from 'react-star-rating-component';

function ChartCard({...props}) {
    const {classes, statIconColor, chart, data, text, statLink, statText} = props;
    /*
    if (data.image) {
        var icon = <img src={ data.image } style={ style } alt={ data.title } />;
    } else {
        var icon = <img width={155} height={155} src={'data:image/svg+xml;base64,' + dappsIcons[value.id]} alt="..." />
    //    var icon = chart;
    }
    */

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const labelStyle = {
        position: 'absolute',
        padding: '2px 6px',
        right: '7px',
        top: '7px',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.14)',
        borderRadius: '2px',
        minWidth: '60px',
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: 'smaller',
        color: 'rgba(0, 0, 0, 0.50)',
    }

    const itemGridStyle = {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding: '0 6px'
    }

    const getLabel = (value) => {
        let style;
        switch (value) {
        case 'new':
            style = {
                background: 'lime'
            }
            break;
        case 'recommended':
            style = {
                background: 'gold'
            }
            break;
        case 'top':
            style = {
                background: 'aqua'
            }
            break;
        default:
            return <div></div>
        }
        return <div style={ Object.assign(style, labelStyle)}>{capitalizeFirstLetter(value)}</div>
    }

    const getClolorByCategory = (category) => {
        switch (category) {
        case 'game':
        case 'games':
            return 'orange';
        case 'marketplace':
        case 'marketplaces':
            return 'green';
        case 'pyramid':
        case 'pyramids':
        case 'casino':
        case 'casinos':
            return 'red';
        default:
            return 'blue';
        }
    }

    const getDescription = (text) => {
        let maxLength = 90;
        if (text.length > maxLength) {
            return text.substr(0, maxLength) + '...';
        } else {
            return text;
        }
    }

    return (
        <Card className={classes.card}>
        <StarRatingComponent
        className="dapp-stars-dashboard"
        name={"rate" + data.id}
        starCount={5}
        value={ data.stars }
        onStarClick={ e => console.log('click star')}
        />
        { getLabel(data.label)}  

          <NavLink
        to={'/dapp/' + data.slug}
        >
      <CardHeader
        className={classes.cardHeader + ' pointer ' + classes[getClolorByCategory(data.category) + "CardHeader"]}
        subheader={ chart }
        />
        </NavLink>

      <CardContent className={classes.cardContent}>
        <Typography variant="title" component="h4" noWrap className={classes.cardTitle}>
          {data.title}
        </Typography>
        <Typography component="p" className={classes.cardCategory}>
          { getDescription(text)}
        </Typography>
      </CardContent>
      <CardActions className={classes.cardActions}>
        <div className={classes.cardStats} style={ {
            width: '100%'
        }}>

        <Grid container spacing={0}>
     
          <ItemGrid xs={4} sm={4} md={6} lg={4} style={ itemGridStyle }>    
              <LocalOffer
        className={classes.cardStatsIcon + " " + classes["CardStatsIcon"]}
        />
              {statLink !== undefined ? (
            <a href={statLink.href} className={classes.cardStatsLink}>
                    { capitalizeFirstLetter(statLink.text)}
                </a>
            ) : statText !== undefined ? (
                capitalizeFirstLetter(statText)
                ) : null}
              
          </ItemGrid>

          <ItemGrid xs={4} sm={4} md={6} lg={4} style={ itemGridStyle }>
          <People
        className={classes.cardStatsIcon + " " + classes[statIconColor + "CardStatsIcon"]
        }
        />{ data.dau }
          </ItemGrid>
<Hidden only={['md']}>
          <ItemGrid xs={4} sm={4} md={4} style={ itemGridStyle }>
          <EthAlt
        className={classes.cardStatsIcon + " " + classes[statIconColor + "CardStatsIcon"]}
        />{data.balance}
          </ItemGrid>
          </Hidden>

        </Grid>

        </div>
      </CardActions>
    </Card>
    );
}

ChartCard.defaultProps = {
    statIconColor: "gray",
//    chartColor: "info"
};

ChartCard.propTypes = {
    classes: PropTypes.object.isRequired,
    chart: PropTypes.object.isRequired,
    title: PropTypes.node,
    text: PropTypes.node,
    //    statIcon: PropTypes.func.isRequired,
    statIconColor: PropTypes.oneOf([
        "warning",
        "primary",
        "danger",
        "success",
        "info",
        "rose",
        "gray"
    ]),
    //    chartColor: PropTypes.oneOf(["orange", "green", "red", "blue", "purple"]),
    statLink: PropTypes.object,
    statText: PropTypes.node
};

export default withStyles(chartCardStyle)(ChartCard);



// WEBPACK FOOTER //
// ./src/components/Cards/ChartCard.jsx